import React from "react";
import { QqControlPropsType } from "./qq-control-props.type";
import { CheckboxControlSettingsModel } from "../model/checkbox-control.settings.model";
import { OptionValueModel } from "../model/option-value.model";
import { checkboxAction } from "../message-interop/control-actions/checkbox.action";
import { QqQuizControlContainerComponent } from "./qq-quiz-control-container.component";
import { FormControlLabel } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { withStyles } from "@mui/styles";

const StyledFormControlLabel = withStyles(() => ({
  label: {
    fontFamily: "Roboto-Medium!important",
    fontSize: `13px !important`,
    color: "#202124",
  },
}))(FormControlLabel);

export const QqCheckboxControl: React.FunctionComponent<
  QqControlPropsType<CheckboxControlSettingsModel, OptionValueModel>
> = ({ qq, settings, dispatch, state }) => {
  const checked = state.ctrlPos[qq.key] === "checked";

  if (qq.visible !== undefined && !qq.visible) return <span />;

  return (
    <QqQuizControlContainerComponent>
      <StyledFormControlLabel
        control={<Checkbox value={checked} />}
        label={qq.text}
        onChange={(_, checked) => {
          dispatch(checkboxAction(qq, checked));
        }}
      />
    </QqQuizControlContainerComponent>
  );
};
